import { atom, selector } from 'recoil';
import { resetOnStudioReset } from '../../effects';
import { isNil } from 'lodash';
import { allUniqViewSubjectsAndCommonBenchmarks } from './allViewSubjects';
import { analysisSubjects } from './subjects';
import { context, defaultContextState } from '../../context';

const analysisViewOwnerContextIdInnerState = atom<string | undefined>({
  key: 'analysisViewOwnerContextIdInnerState',
  default: undefined,
  effects: [resetOnStudioReset],
});

export const analysisViewOwnerContextIdState = selector<string | undefined>({
  key: 'analysisViewOwnerContextIdState',
  get: ({ get }) => {
    const innerState = get(analysisViewOwnerContextIdInnerState);
    if (!isNil(innerState)) {
      return innerState;
    }
    const allSubjects = get(analysisSubjects(get(allUniqViewSubjectsAndCommonBenchmarks)));
    const firstContext = allSubjects
      .map((s) => s.portfolio?.ownerContextId)
      .find((id) => !isNil(id) && get(context(id))?.actionEnums.includes('EDIT_ANALYSIS_VIEW'));
    return firstContext ?? get(defaultContextState);
  },
  set: ({ set }, newValue) => {
    set(analysisViewOwnerContextIdInnerState, newValue);
  },
});
